import axiosInstance from "./axiosInstance";
import { acquireAbortController, releaseAbortController } from "./abortManager";

export async function axiosWithAbort(key, config) {
  const controller = acquireAbortController(key);

  try {
    const response = await axiosInstance({
      ...config,
      signal: controller.signal,
    });

    return response;
  } catch (err) {
    if (err.name === "CanceledError") {
      console.info(`[aborted] ${key}`);
      return null;
    }
    throw err;
  } finally {
    // Pass the specific controller so only this call's entry is removed,
    // not a newer controller that may have replaced it in the map.
    releaseAbortController(key, controller);
  }
}
